var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8723 5.25H13.1209V6.12363C13.1209 7.0875 12.3375 7.875 11.3695 7.875C10.4057 7.875 9.61816 7.0916 9.61816 6.12363V5.25H6.11953V6.12363C6.11953 7.0875 5.33613 7.875 4.36816 7.875C3.4043 7.875 2.6168 7.0916 2.6168 6.12363V5.25H0.873633C0.873633 13.9986 0 21 0 21H15.75C15.7459 21 14.8723 13.9986 14.8723 5.25ZM4.37227 7.00137C4.85625 7.00137 5.2459 6.61172 5.2459 6.12773V4.37637C5.2459 2.92441 6.41894 1.75137 7.8709 1.75137C9.32285 1.75137 10.4959 2.92441 10.4959 4.37637V6.12773C10.4959 6.61172 10.8855 7.00137 11.3695 7.00137C11.8535 7.00137 12.2432 6.61172 12.2432 6.12773V4.37637C12.2473 1.96055 10.2867 0 7.8709 0C5.45508 0 3.49453 1.96055 3.49453 4.37637V6.12773C3.49863 6.60762 3.88828 7.00137 4.37227 7.00137Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderList);
export default __webpack_public_path__ + "static/media/order-list.cfd6f761b0f54156f062beac181ea017.svg";
export { ForwardRef as ReactComponent };